


























































import CommonIconBtn from '@/components/Common/CommonIconBtn.vue';
import { Component, Ref, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { FileAnalysisModule } from '@/store/modules/file_analysis';
import { getStuDataApi } from '@/api/student-management'

@Component({
  name: 'studentApplicationForm',
  components: {
    CommonIconBtn,
  }
})
export default class extends Vue {
  @Ref('allFormComp') public allFormComp!: any;

  get studentId() {
    if (isNaN(Number(this.$route.params.stuid))) {
      return '';
    }
    return Number(this.$route.params.stuid);
  }

  get companyId() {
    return UserModule.companyId;
  }

  get getLan() {
    return this.$i18n.locale;
  }

  get agentId() {
    if (isNaN(Number(UserModule.fkAgentId))) {
      return ''
    }
    return Number(UserModule.fkAgentId);
  }

  get sidebar() {
    return AppModule.sidebar;
  }

  get token() {
    return UserModule.getToken;
  }

  get publicFilesUrl() {
    return UserModule.publicFilesUrl;
  }

  get privateFilesUrl() {
    return UserModule.privateFilesUrl;
  }

  get bmsLogin() {
    return UserModule.bmsLogin;
  }

  get issueInnerAccount() {
    return UserModule.issueInnerAccount;
  }

  get eduBackInfo() {
    const eduBack = FileAnalysisModule.eduBack;
    if (eduBack && eduBack.length) {
      return eduBack;
    }
    return undefined;
  }

  get workExpInfo() {
    const workExp = FileAnalysisModule.workExp;
    if (workExp && workExp.length) {
      return workExp;
    }
    return undefined;
  }

  get getSubFkPlatFormType() {
    return UserModule.subFkPlatformType;
  }

  public fromRoute: any = null;
  public studentName: string = '';

  public beforeRouteEnter(to: any, from: any, next: any) {
    if (from.name === 'studentInformation') {
      next((vm: any) => {
        vm.fromRoute = from;
      });
    } else {
      next();
    }
  }

  public mounted() {
    const studentName = this.$route.params.stu;
    if (studentName) {
      this.studentName = decodeURIComponent(studentName);
    } else  {
      this.getStudentName();
    }
  }

  public beforeDestroy() {
    FileAnalysisModule.SET_WORK_EXP([]);
    FileAnalysisModule.SET_EDU_BACK([]);
    FileAnalysisModule.SET_PERSON_INFO({});
  }

  public async getStudentName() {
    try {
      const stuId = this.$route.params.stuid;
      const { data } = await getStuDataApi(Number(stuId), 'issue');
      this.studentName = `${data.data.lastName} ${data.data.firstName}`;
    } catch (error) {
      //
    }
  }

  public returnToStudentPage() {
    if (this.fromRoute) {
      this.$router.replace(this.fromRoute);
    }
  }
}
